import * as tslib_1 from "tslib";
import { NotificationsStore } from './notifications.store';
import { NotificationsQuery } from './notifications.query';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "./notifications.store";
import * as i2 from "./notifications.query";
import * as i3 from "@angular/common/http";
var NotificationsService = /** @class */ (function () {
    function NotificationsService(_notificationsStore, _notificationsQuery, _http) {
        this._notificationsStore = _notificationsStore;
        this._notificationsQuery = _notificationsQuery;
        this._http = _http;
    }
    NotificationsService.prototype.get = function () {
        var _this = this;
        this.setLoading(true);
        this._http.get(environment.apiRoot + "/agriscouting/api/notifications")
            .subscribe(function (response) {
            _this.setLoading(false);
            _this._notificationsStore.set(response.content);
        }, function (err) {
            _this.setLoading(false);
            _this.setError(err);
        });
    };
    NotificationsService.prototype.getMapUnitParents = function (fieldId, cropYear) {
        var params = new HttpParams()
            .set('size', '100')
            .set('cropYear', cropYear)
            .set('fieldId', fieldId.toString());
        return this._http.get(environment.apiRoot + "/agriscouting/api/mapUnits/parents", { params: params });
    };
    NotificationsService.prototype.markAsReaded = function (ids) {
        var _this = this;
        var data = ids.map(function (id) {
            return { id: id, readed: true };
        });
        this._http.put(environment.apiRoot + "/agriscouting/api/notifications", data)
            .subscribe(function () { return _this.get(); }, function (err) { return _this.setError(err); });
    };
    NotificationsService.prototype.setSelectedDate = function (date) {
        this._notificationsStore.updateRoot({ planningSelectedDate: date });
    };
    NotificationsService.prototype.getPlanningSelectedDate = function () {
        return this._notificationsQuery.getValue().planningSelectedDate;
    };
    NotificationsService.prototype.setLoading = function (value) {
        this._notificationsStore.setLoading(value);
    };
    NotificationsService.prototype.setError = function (error) {
        this._notificationsStore.setError(error);
    };
    NotificationsService.prototype.saveParents = function (fieldId, parents) {
        this._notificationsStore.updateRoot(function (state) {
            var savedParents = tslib_1.__assign({}, state.savedParents);
            savedParents[fieldId] = parents;
            return tslib_1.__assign({}, state, { savedParents: savedParents });
        });
    };
    NotificationsService.prototype.getSavedParents = function (fieldId) {
        return this._notificationsQuery.getValue().savedParents[fieldId];
    };
    NotificationsService.prototype.getActiveReportTab = function () {
        return this._notificationsQuery.getValue().selectedReportTab || 0;
    };
    NotificationsService.prototype.setActiveReportTab = function (tabNumber) {
        this._notificationsStore.updateRoot({ selectedReportTab: tabNumber });
    };
    NotificationsService.ngInjectableDef = i0.defineInjectable({ factory: function NotificationsService_Factory() { return new NotificationsService(i0.inject(i1.NotificationsStore), i0.inject(i2.NotificationsQuery), i0.inject(i3.HttpClient)); }, token: NotificationsService, providedIn: "root" });
    return NotificationsService;
}());
export { NotificationsService };
